import { createRoot } from "react-dom/client";
import App from "./App.tsx";

// Self-hosted fonts (eliminates Google Fonts render-blocking request).
import "@fontsource/rubik/hebrew-400.css";
import "@fontsource/rubik/hebrew-500.css";
import "@fontsource/rubik/hebrew-700.css";
import "@fontsource/rubik/hebrew-900.css";
import "@fontsource/fredoka/hebrew-500.css";
import "@fontsource/fredoka/hebrew-700.css";
import "@fontsource/vina-sans/latin-400.css";
import "@fontsource/playpen-sans-hebrew/hebrew-500.css";
import "@fontsource/playpen-sans-hebrew/hebrew-700.css";
import "@fontsource/playwrite-at/400.css";

import "./index.css";

// Note: the LCP hero image preload is injected directly into index.html at
// build time by the `preload-lcp-hero` Vite plugin, so the browser starts
// fetching it during HTML parse instead of waiting for this JS bundle.

createRoot(document.getElementById("root")!).render(<App />);
